// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"960":"080b975b","1097":"7d9faf8c","2853":"7d9faf8c","3019":"7d9faf8c","3384":"b9d46c09","3405":"17100d33","3870":"21584469","5285":"7d9faf8c","5398":"935e645a","7097":"7d9faf8c","7219":"b9d46c09"}[chunkId] + ".chunk.css";
};